import React, { Component } from "react";
import "./ContentBlockSuggestionList.css";

/**
 * 内容块建议列表组件
 * 用于 @ 提及功能，显示可选的内容块列表
 * 必须是类组件，因为 ReactRenderer 需要通过 ref 调用 onKeyDown 方法
 */
class ContentBlockSuggestionList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: 0,
        };
    }

    // 当 items 变化时重置选中索引
    componentDidUpdate(prevProps) {
        if (prevProps.items !== this.props.items) {
            this.setState({ selectedIndex: 0 });
        }
    }

    // 键盘事件处理 - 这个方法会被 ReactRenderer 调用
    onKeyDown({ event }) {
        if (event.key === "ArrowUp") {
            this.upHandler();
            return true;
        }

        if (event.key === "ArrowDown") {
            this.downHandler();
            return true;
        }

        if (event.key === "Enter") {
            this.enterHandler();
            return true;
        }

        return false;
    }

    upHandler() {
        const { items } = this.props;
        this.setState({
            selectedIndex: (this.state.selectedIndex + items.length - 1) % items.length,
        });
    }

    downHandler() {
        const { items } = this.props;
        this.setState({
            selectedIndex: (this.state.selectedIndex + 1) % items.length,
        });
    }

    enterHandler() {
        this.selectItem(this.state.selectedIndex);
    }

    selectItem(index) {
        const { items, command } = this.props;
        const item = items[index];
        if (item) {
            command(item);
        }
    }

    render() {
        const { items } = this.props;
        const { selectedIndex } = this.state;

        if (!items || items.length === 0) {
            return (
                <div className="content-block-suggestion-list">
                    <div className="suggestion-empty">没有找到匹配的内容块</div>
                </div>
            );
        }

        return (
            <div className="content-block-suggestion-list">
                {items.map((item, index) => (
                    <div key={item.id || index} className={`suggestion-item ${index === selectedIndex ? "suggestion-item-selected" : ""}`} onClick={() => this.selectItem(index)}>
                        <div className="suggestion-item-icon">{item.icon || "📝"}</div>
                        <div className="suggestion-item-content">
                            <div className="suggestion-item-title">{item.contentBlockLabel || item.title}</div>
                            <div className="suggestion-item-description">{item.description}</div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }
}

export default ContentBlockSuggestionList;
